const scope = 'dashbordStore/storeConfig'

export const GET_STORE_REQUEST = `${scope}/GET_STORE_REQUEST`;
export const GET_STORE_SUCCESS = `${scope}/GET_STORE_SUCCESS`;
export const GET_STORE_FAIL = `${scope}/GET_STORE_FAIL`;